import React from "react";
import EtapesTodosConfigForm from "./EtapesTodosConfigForm";
import styles from "./EnveloppeTable.module.scss";

/**
 * Panneau de configuration d'une enveloppe (LS-632, étendu par la
 * configuration héritée du financeur) :
 * - Étapes actives du parcours (figées dès que l'enveloppe est verrouillée).
 * - Todos par étape (toujours éditables, même verrouillée).
 * - Tant que l'enveloppe n'a pas été surchargée ni verrouillée
 *   (`override=false`), elle suit en direct le gabarit par défaut du
 *   financeur ; toute sauvegarde ici la détache définitivement de ce gabarit.
 *
 * Props :
 * - enveloppe : { uuid, etapesActives, verrouillee, todos, override }
 * - onModifierEtapes(enveloppeUuid, etapesActives) : Promise<bool>
 * - onSynchroniserTodos(enveloppeUuid, todos) : Promise<bool>
 */
const EnveloppeConfigPanel = ({
  enveloppe,
  onModifierEtapes,
  onSynchroniserTodos,
}) => (
  <EtapesTodosConfigForm
    etapesActives={enveloppe.etapesActives}
    todos={enveloppe.todos}
    locked={enveloppe.verrouillee}
    lockedHint={
      <>
        <i className="fa fa-lock" /> Figées : au moins une demande liée a
        dépassé Brouillon.
      </>
    }
    banner={
      !enveloppe.override &&
      !enveloppe.verrouillee && (
        <div className={styles.hint}>
          <i className="fa fa-link" /> Suit le gabarit par défaut du
          financeur — toute modification ici la personnalise pour cette
          enveloppe uniquement.
        </div>
      )
    }
    confirmFirstSave={
      !enveloppe.override && !enveloppe.verrouillee
        ? "Personnaliser cette enveloppe ?\nElle ne suivra plus le gabarit par défaut du financeur."
        : null
    }
    onSaveEtapes={(etapes) => onModifierEtapes(enveloppe.uuid, etapes)}
    onSaveTodos={(todos) => onSynchroniserTodos(enveloppe.uuid, todos)}
  />
);

export default EnveloppeConfigPanel;
